<div class="modal modal-blur show d-block" *ngIf="open" role="dialog" aria-modal="true" aria-labelledby="contributor-modal-title">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <div>
          <h2 id="contributor-modal-title" class="modal-title">{{ contributor ? 'Edit' : 'New' }} pipeline contributor</h2>
          <div class="text-secondary small">Attach an Employee Group to one code-owned contributor role.</div>
        </div>
        <button type="button" class="btn-close" aria-label="Close" (click)="closed.emit()"></button>
      </div>
      <div class="modal-body">
        <div class="alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</div>
        <div class="mb-3">
          <label class="form-label required" for="contributor-role">Contributor role</label>
          <select id="contributor-role" class="form-select" [(ngModel)]="roleCode">
            <option value="">Select a role</option>
            <option *ngFor="let role of roles" [value]="role.code" [disabled]="role.code === 'creator'">
              {{ role.name }}{{ role.required ? ' · Required' : '' }}
            </option>
          </select>
          <small class="form-hint">Role capabilities and owner-command permissions come from the business-document schema.</small>
        </div>
        <div class="mb-3">
          <label class="form-label required" for="contributor-group">Employee Group</label>
          <app-autocomplete-select id="contributor-group" [(ngModel)]="employeeGroupId"
            [ngModelOptions]="{ standalone: true }" [options]="employeeGroups"
            [allowEmptyOption]="false" placeholder="Select an Employee Group">
          </app-autocomplete-select>
          <small class="form-hint">Employees are resolved through their active employment and group membership.</small>
        </div>
        <label class="form-check form-switch">
          <input class="form-check-input" type="checkbox" [(ngModel)]="grantsAccess">
          <span class="form-check-label">Contributor grants document access</span>
        </label>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn" (click)="closed.emit()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="submit()">Save contributor</button>
      </div>
    </div>
  </div>
</div>
